<ng-container *transloco="let t">
  <div class="flex w-[60rem] flex-col gap-4">
    <div class="form-group row my-2 items-center">
      <span class="prepend col-6"
        >{{ t("vendor-metrics-popup.select_the_vendor_metrics", [modalData.accountMarketplace.accountName]) }}
      </span>
      <div class="col-6">
        <IButton
          class="mx-2"
          [color]="modalData.accountMarketplace.useSourcingMetrics ? 'main' : 'white'"
          type="submit"
          [label]="t('vendor-metrics-popup.sourcing')"
          (onClick)="updateVendorMetrics(true)"
        />

        <IButton
          class="mx-2"
          [color]="modalData.accountMarketplace.useSourcingMetrics ? 'white' : 'main'"
          type="submit"
          [label]="t('vendor-metrics-popup.manufacturing')"
          (onClick)="updateVendorMetrics(false)"
        />
      </div>
    </div>
  </div>
  <div class="flex justify-end gap-2">
    <IButton color="white" [label]="t('common.close')" (onClick)="modalRef.close()" />
  </div>
</ng-container>
